import { useEffect, useRef } from 'react';
import { googleAdInteract } from '../../apis/ads.api';

const viewedAdSlots = new Set(); // Track unique ad views per session

const GoogleAd = ({
  articleId,
  key,
  slot,
  className,
  format,
  adLayout,
  textAlign,
  uniqueKey,
  ...rest
}) => {
  const adRef = useRef(null);

  const trackKey = uniqueKey || slot;

  useEffect(() => {
    try {
      setTimeout(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }, 500);
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  useEffect(() => {
    if (!adRef.current || !trackKey || viewedAdSlots.has(trackKey)) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting) {
            if (!viewedAdSlots.has(trackKey)) {
              viewedAdSlots.add(trackKey);
              await googleAdInteract(articleId).catch((err) =>
                console.error('Track impression failed:', err)
              );
            }
            obs.unobserve(entry.target); // Stop observing after first view
          }
        });
      },
      {
        threshold: 0.1 // 10% visible
      }
    );

    observer.observe(adRef.current);

    return () => {
      observer.disconnect();
    };
  }, [trackKey]);

  return (
    <ins
      ref={adRef}
      style={{
        display: 'block',
        ...(textAlign ? { textAlign } : {})
      }}
      className={`adsbygoogle ${className}`}
      data-ad-client={process.env.REACT_APP_AD_SENSE_ID}
      data-ad-slot={slot}
      data-adtest="off"
      data-ad-format={format || 'auto'}
      data-ad-layout={adLayout}
      data-full-width-responsive="true"
      {...rest}
    />
  );
};

export default GoogleAd;
